import {
  IListViewTableColumns,
  RowsPerPage,
} from '~/src/dash/components/tables/ListViewTable/common';
import { FONT_WEIGHT } from '~/src/dash/components/text/common';
import { spacing } from '~/src/dash/publicaUI';

type orderDirection = 'asc' | 'desc';

interface IAdBreakTable {
  columns: IListViewTableColumns;
}

export interface IAdBreakConfig {
  cypressClassName: string;
  defaultState: {
    activeColumnKeys: string[];
    isTableExpanded: boolean;
    orderDirection: orderDirection;
    orderBy: string;
    page: number;
    rowsPerPage: RowsPerPage;
  };
  columnSelector: {
    resetKeys?: string[];
  };
  table: IAdBreakTable;
}

export const adBreakTableConfig = {
  cypressClassName: 'InventoryRulesAllRules',
  defaultState: {
    activeColumnKeys: [
      'PodDuration',
      'SlotCount',
      'MinAdDuration',
      'MaxAdDuration',
      'CuePointTypes',
      'CuePointValue',
    ],
    isTableExpanded: false,
    orderDirection: 'asc',
    orderBy: 'Name',
    page: 0,
    rowsPerPage: 25,
  },
  columnSelector: {
    resetKeys: ['Name'],
  },
  table: {
    columns: {
      ID: {
        formatValue: (value: number) => String(value),
        isHidden: true,
        isSearchable: true,
        key: 'ID',
        label: 'ID',
        requestKey: '',
        responseKey: 'ID',
        valueType: 'string',
      },
      Name: {
        defaultOrderDirection: 'asc',
        headerRenderType: 'drawer_string',
        cellRenderType: 'drawer_string',
        cellStyle: {
          fontWeight: FONT_WEIGHT.base,
          paddingRight: spacing.large,
        },
        isSearchable: true,
        key: 'Name',
        tKey: 'AdBreakID',
        label: 'Ad Break ID',
        requestKey: 'AdBreakID',
        responseKey: 'AdBreakID',
        valueType: 'string',
        orderByKey: 'Name',
      },
      PodDuration: {
        defaultOrderDirection: 'asc',
        headerRenderType: 'drawer_number',
        cellRenderType: 'drawer_number',
        cellStyle: {
          fontWeight: FONT_WEIGHT.base,
          paddingRight: spacing.large,
        },
        isSearchable: true,
        key: 'PodDuration',
        tKey: 'PodDurations',
        label: 'Pod Duration',
        requestKey: '',
        responseKey: 'PodDuration',
        valueType: 'number',
        orderByKey: 'PodDuration',
      },
      SlotCount: {
        defaultOrderDirection: 'asc',
        headerRenderType: 'drawer_number',
        cellRenderType: 'drawer_number',
        isSearchable: true,
        key: 'SlotCount',
        tKey: 'SlotCount',
        label: 'Slot Count',
        requestKey: '',
        responseKey: 'SlotCount',
        valueType: 'number',
        orderByKey: 'SlotCount',
      },
      MinAdDuration: {
        defaultOrderDirection: 'asc',
        headerRenderType: 'drawer_string',
        cellRenderType: 'drawer_string',
        isSearchable: true,
        key: 'MinAdDuration',
        tKey: 'MinAdDuration',
        label: 'Min Ad Dur.',
        requestKey: '',
        responseKey: 'MinAdDuration',
        valueType: 'string',
        orderByKey: 'MinAdDuration',
      },
      MaxAdDuration: {
        defaultOrderDirection: 'asc',
        headerRenderType: 'drawer_string',
        cellRenderType: 'drawer_string',
        isSearchable: true,
        key: 'MaxAdDuration',
        tKey: 'MaxAdDuration',
        label: 'Max Ad Dur.',
        requestKey: '',
        responseKey: 'MaxAdDuration',
        valueType: 'string',
        orderByKey: 'MaxAdDuration',
      },
      CuePointTypes: {
        defaultOrderDirection: 'asc',
        headerRenderType: 'drawer_number',
        cellRenderType: 'drawer_number',
        isSearchable: true,
        key: 'CuePointTypes',
        tKey: 'CuePointTypes',
        label: 'Cue Point Types',
        requestKey: '',
        responseKey: 'CuePointTypes',
        valueType: 'string',
        orderByKey: 'CuePointTypes',
      },
      CuePointValue: {
        defaultOrderDirection: 'asc',
        headerRenderType: 'drawer_string',
        cellRenderType: 'drawer_string',
        isSearchable: true,
        key: 'CuePointValue',
        tKey: 'CuePointValue',
        label: 'Cue Point Value',
        requestKey: '',
        responseKey: 'CuePointValue',
        valueType: 'string',
        orderByKey: 'CuePointValue',
      },
    },
  },
} as IAdBreakConfig;
